import React from "react";

import Circular from "./Circular";
import Linear from "./Linear";

import * as constants from "./constants";

import styles from "./ProgressIndicator.module.scss";

interface AccessibleIndicatorProps {
  progress: number;
  type: (typeof constants.TYPES)[number];
}

const AccessibleIndicator: React.FC<AccessibleIndicatorProps> = ({
  progress,
  type,
}) => {
  let value;
  let max;

  if (type === constants.TYPE_DETERMINATE) {
    value = progress;
    max = 100;
  }

  return (
    <progress className={styles.hiddenAccessible} value={value} max={max} />
  );
};

export interface ProgressIndicatorProps {
  /**
   * size and stroke of the loader
   * (small-thin, small-chunky, large-thin, large-chunky)
   */
  size: (typeof constants.SIZE_NAMES)[number];

  /**
   * shape of the loader (linear | circular)
   */
  shape: (typeof constants.SHAPES)[number];

  /**
   * Type of indicator for the loader (indeterminate | determinate)
   */
  type: (typeof constants.TYPES)[number];

  /**
   * Style of the loader (dark | light | gradient | progress)
   */
  style: (typeof constants.STYLES)[number];

  /**
   * Progress bar if the chosen Type is determinate
   */
  progress: number;

  className?: string;
}

export class ProgressIndicator extends React.PureComponent<ProgressIndicatorProps> {
  static defaultProps = {
    size: constants.SIZE_LARGE_CHUNKY,
    shape: constants.SHAPE_CIRCULAR,
    type: constants.TYPE_INDETERMINATE,
    style: constants.STYLE_DARK,
    progress: 0,
  };

  render() {
    const { size, shape, type, style, progress, className } = this.props;

    return (
      <div>
        {shape === constants.SHAPE_CIRCULAR ? (
          <Circular
            size={size}
            type={type}
            style={style}
            progress={progress}
            className={className}
          />
        ) : (
          <Linear
            type={type}
            style={style}
            progress={progress}
            className={className}
          />
        )}
        <AccessibleIndicator progress={progress} type={type} />
      </div>
    );
  }
}
